import { Configuration } from "@azure/msal-browser";

const requiredAuthEnv = {
  VITE_MSAL_CLIENT_ID: import.meta.env.VITE_MSAL_CLIENT_ID,
  VITE_B2C_ADMINDELETE: import.meta.env.VITE_B2C_ADMINDELETE,
  VITE_B2C_ADMINREAD: import.meta.env.VITE_B2C_ADMINREAD,
  VITE_B2C_ADMINWRITE: import.meta.env.VITE_B2C_ADMINWRITE,
  VITE_B2C_AUTHORITY_DOMAIN: import.meta.env.VITE_B2C_AUTHORITY_DOMAIN,
  VITE_B2C_CUSTOMERREAD: import.meta.env.VITE_B2C_CUSTOMERREAD,
  VITE_B2C_CUSTOMERWRITE: import.meta.env.VITE_B2C_CUSTOMERWRITE,
  VITE_B2C_SIGN_UP_SIGN_IN_AUTHORITY: import.meta.env.VITE_B2C_SIGN_UP_SIGN_IN_AUTHORITY
};

export const missingAuthEnvVars = Object.entries(requiredAuthEnv)
  .filter(([, value]) => !value)
  .map(([key]) => key);

export const isAuthConfigured = missingAuthEnvVars.length === 0;

export const b2cPolicies = {
  names: {
      signUpSignIn: import.meta.env.VITE_B2C_SIGN_UP_SIGN_IN_NAME,
      forgotPassword: import.meta.env.VITE_B2C_FORGOT_PASSWORD_NAME,
  },
  authorities: {
      signUpSignIn: {
        authority: import.meta.env.VITE_B2C_SIGN_UP_SIGN_IN_AUTHORITY,
      },
      forgotPassword: {
        authority: import.meta.env.VITE_B2C_FORGOT_PASSWORD_AUTHORITY,
      }
  },
  authorityDomain: import.meta.env.VITE_B2C_AUTHORITY_DOMAIN
};

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_MSAL_CLIENT_ID,
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: [b2cPolicies.authorityDomain],
    redirectUri: '/', 
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
}

//TODO: Add protected resources as web api develops
export const protectedResources = {
  admin: {
    scopes: {
      read: [import.meta.env.VITE_B2C_ADMINREAD],
      write: [import.meta.env.VITE_B2C_ADMINWRITE],
      delete: [import.meta.env.VITE_B2C_ADMINDELETE],
    }
  },
  customer: {
    scopes: {
      read: [import.meta.env.VITE_B2C_CUSTOMERREAD],
      write: [import.meta.env.VITE_B2C_CUSTOMERWRITE],
    }
  }
}

export const loginRequest = {
  scopes: [
    ...protectedResources.admin.scopes.read, 
    ...protectedResources.admin.scopes.write, 
    ...protectedResources.admin.scopes.delete, 
    ...protectedResources.customer.scopes.read, 
    ...protectedResources.customer.scopes.write
  ],
};
